/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { EuiPageTemplate } from "@inscopix/ideas-eui";
import { HeaderDashboard } from "components/HeaderDashboard/HeaderDashboard";
import { PanelProjects } from "components/PanelProjects/PanelProjects";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { useRef } from "react";

export const PageOrganizationExternalDashboard = () => {
  const currentTenant = useTenantContext((s) => s.currentTenant);

  const virtuaScrollRef = useRef<HTMLDivElement>(null);
  return (
    <EuiPageTemplate
      panelled={true}
      bottomBorder={"extended"}
      grow={true}
      style={{ maxWidth: 1000, margin: "auto", height: "100%" }}
      mainProps={{
        css: css`
          overflow: auto;
          max-block-size: calc(100vh - var(--euiFixedHeadersOffset, 0));
        `,
      }}
    >
      <HeaderDashboard
        tenantId={currentTenant.id}
        title={`${currentTenant.name} projects shared with me`}
        showCreateProject={false}
      />

      <div
        css={css`
          max-width: 1000px;
          margin: auto;
          width: max(600px, 75vw);
          height: 100%;
        `}
        ref={virtuaScrollRef}
      >
        <PanelProjects
          virtuaScrollRef={virtuaScrollRef}
          tenantId={currentTenant.id}
        />
      </div>
    </EuiPageTemplate>
  );
};
